<template>
  <div>
    <b-row class="match-height">
      <b-col
        cols="12"
        xl="12"
      >
        <b-card no-body class="cancel-top">
          <b-card-body>
            <div class="cancel-text">
              <feather-icon
                class="alert-icon"
                icon="AlertTriangleIcon"
              />
              <span class="cancel-title">
                Cancelamento de conta - comentários
              </span>
            </div>
          </b-card-body>
        </b-card>
        <b-card no-body>
          <b-card-body class="offset-1 col-10">
            <b-table
              :items="items"
              :fields="fields"
              striped
              responsive
              class="user-list mb-0"
            >
              <template #cell(avatar)="data">
                <b-avatar :src="data.value" />
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
      <template #code>
        {{ codeRowDetailsSupport }}
      </template>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BCardText, BButton, BRow, BCol, BCardBody,
  BFormGroup, BFormInput, BInputGroup, BInputGroupPrepend,
  BTable, BFormCheckbox, BAvatar, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { codeRowDetailsSupport } from './code'

export default {
  components: {
    BCard,
    BCardText,
    BButton,
    BCardBody,
    BRow,
    BCol,
    BFormGroup, 
    BFormInput, 
    BInputGroup, 
    BInputGroupPrepend,
    BTable, 
    BFormCheckbox, 
    BAvatar, 
    BBadge,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fields: [{ key: 'avatar', label: '' }, {key: 'full_name', label: this.$t('NAME')}, {key: 'comment', label: this.$t('REASON FOR CANCELLATION (free text)')}, { key: 'date', label: this.$t('DATE') }],
      /* eslint-disable global-require */
      items: [
        {
          id: 1,
          avatar: require('@/assets/images/avatars/10-small.png'),
          full_name: "Korrie O'Crevy",
          comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          date: '23-01-2022 12:00',
        },
        {
          id: 2,
          avatar: require('@/assets/images/avatars/1-small.png'),
          full_name: 'Bailie Coulman',
          comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          date: '23-01-2022 12:00',
        },
        {
          id: 3,
          avatar: require('@/assets/images/avatars/9-small.png'),
          full_name: 'Stella Ganderton',
          comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          date: '23-01-2022 12:00',
        },
      ],
      codeRowDetailsSupport,
    }
  },
}
</script>